import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import clienteAxios from '../../config/axios';
import AuthShell from './AuthShell';
import { useT } from 'i18n';

const Activation = (props) => {
  const { t, ts } = useT();
  const [estado, setEstado] = useState('cargando'); // cargando | ok | error
  const [texto, setTexto] = useState('');

  useEffect(() => {
    let vivo = true;
    clienteAxios.get(`/api/client/activation/${props.match.params.token}`)
      .then((r) => { if (vivo) { setEstado('ok'); setTexto(r.data?.message || ''); } })
      .catch((e) => { if (vivo) { setEstado('error'); setTexto(e.response?.data?.message || ''); } });
    return () => { vivo = false; };
  }, [props.match.params.token]);

  return (
    <AuthShell>
      <div className="p7a-estado">
        {estado === 'cargando' && (<><div className="p7a-icono espera" aria-hidden="true">…</div><h2>{t('activar.validando')}</h2><p>{t('activar.momento')}</p></>)}
        {estado === 'ok' && (<><div className="p7a-icono ok" aria-hidden="true">✓</div><h2>{t('activar.confirmado')}</h2><p>{t('activar.activa')}</p></>)}
        {estado === 'error' && (<><div className="p7a-icono err" aria-hidden="true">!</div><h2>{t('activar.noValido')}</h2><p>{ts(texto) || t('activar.errorEnlace')} {t('activar.noValidoTxt')}</p></>)}
        {estado !== 'cargando' && <Link to="/login" className="p7a-btn" style={{ display: 'block', textAlign: 'center', textDecoration: 'none' }}>{t('activar.iniciar')}</Link>}
      </div>
    </AuthShell>
  );
};

export default Activation;
